import { render, staticRenderFns } from "./QuoteRequests.vue?vue&type=template&id=45a10a34"
import script from "./QuoteRequests.vue?vue&type=script&lang=js"
export * from "./QuoteRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports